/* QOWAA FIT — Page PACK (comportements)
   Recréé en vanilla JS depuis le prototype « Pack QOWAA FIT.html ».
   Modèle Shopify : 1 produit pack, options natives = taille par pièce, variantes = combinaisons.
   Le Step Selector mappe la combinaison choisie vers le variant Shopify exact (matching option1/2/3).
   Réutilise les widgets partagés (galerie, lightbox, panier, accordéons) avec les mêmes
   attributs data-pdp-* que la PDP, plus un moteur de steps data-pack-*. */
(function () {
  'use strict';
  var DESK = 1000;
  function isDesktop() { return window.innerWidth >= DESK; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function moneyNum(cents) { return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function money(cents) { return moneyNum(cents) + ' €'; }
  function moneyHtml(cents) { return moneyNum(cents) + ' <span class="qw-cur">€</span>'; }

  // ───────── GALERIE + LIGHTBOX (identique PDP) ─────────
  function initGallery(root) {
    var gallery = $('[data-pdp-gallery]', root);
    if (!gallery) return;
    var track = $('.gallery__track', gallery);
    var slides = $all('.gallery__slide', track);
    var thumbs = $all('[data-pdp-thumb]', gallery);
    var dots = $all('.gallery__dot', gallery);
    var counter = $('[data-pdp-counter]', gallery);
    var total = slides.length, idx = 0, startX = null, deltaX = 0;
    function pad(n) { return ('0' + n).slice(-2); }
    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }
    function go(i) { idx = Math.max(0, Math.min(total - 1, i)); render(); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var main = $('.gallery__main', gallery);
    main.addEventListener('touchstart', function (e) { if (isDesktop()) return; startX = e.touches[0].clientX; deltaX = 0; track.style.transition = 'none'; }, { passive: true });
    main.addEventListener('touchmove', function (e) { if (isDesktop() || startX == null) return; deltaX = e.touches[0].clientX - startX; track.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + (deltaX / main.offsetWidth * 100) + '%))'; }, { passive: true });
    main.addEventListener('touchend', function () { if (isDesktop() || startX == null) return; track.style.transition = ''; if (deltaX < -40) go(idx + 1); else if (deltaX > 40) go(idx - 1); else render(); startX = null; deltaX = 0; });
    var lb = $('[data-pdp-lightbox]', root);
    if (lb) {
      var stage = $('[data-pdp-lightbox-stage]', lb), lbCounter = $('[data-pdp-lightbox-counter]', lb), lbIdx = 0;
      function lbRender() {
        var src = slides[lbIdx] ? slides[lbIdx].getAttribute('data-zoom-src') : '';
        stage.innerHTML = src ? '<img src="' + src + '" alt="">' : '<span class="gallery__lbl">' + (slides[lbIdx] ? (slides[lbIdx].getAttribute('data-label') || '') : '') + '</span>';
        if (lbCounter) lbCounter.textContent = pad(lbIdx + 1) + ' / ' + pad(total) + ' · ZOOM';
      }
      function lbOpen(i) { lbIdx = i; lbRender(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function lbClose() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
      main.addEventListener('click', function (e) { if (e.target.closest('[data-pdp-video-play]')) return; lbOpen(idx); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === stage || e.target.closest('[data-pdp-lightbox-close]')) lbClose(); });
      var pv = $('[data-pdp-lightbox-prev]', lb), nx = $('[data-pdp-lightbox-next]', lb);
      if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); lbIdx = Math.max(0, lbIdx - 1); lbRender(); });
      if (nx) nx.addEventListener('click', function (e) { e.stopPropagation(); lbIdx = Math.min(total - 1, lbIdx + 1); lbRender(); });
      document.addEventListener('keydown', function (e) { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') lbClose(); if (e.key === 'ArrowRight') { lbIdx = Math.min(total - 1, lbIdx + 1); lbRender(); } if (e.key === 'ArrowLeft') { lbIdx = Math.max(0, lbIdx - 1); lbRender(); } });
    }
    $all('[data-pdp-video-play]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); var sl = btn.closest('.gallery__slide'); var v = sl && sl.querySelector('video'); if (v) { sl.querySelectorAll('.gallery__slide-overlay,[data-pdp-video-play],.gallery__lbl').forEach(function (el) { el.style.display = 'none'; }); v.setAttribute('controls', ''); v.play().catch(function () {}); } });
    });
    render();
  }

  // ───────── ACCORDÉONS + MODALE TAILLES (identique PDP) ─────────
  function initAccordions(root) {
    $all('[data-pdp-acc-group]', root).forEach(function (group) {
      var single = group.getAttribute('data-pdp-acc-group') === 'single';
      $all('.acc', group).forEach(function (acc) {
        var btn = $('.acc__btn', acc);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = acc.classList.contains('is-open');
          if (single) $all('.acc', group).forEach(function (a) { a.classList.remove('is-open'); var b = a.querySelector('.acc__btn'); if (b) b.setAttribute('aria-expanded', 'false'); });
          acc.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }
  function initSizeModal(root) {
    var modal = $('[data-pdp-size-modal]', root);
    if (!modal) return;
    function open() { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    $all('[data-pack-guide-link]', root).forEach(function (l) { l.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $all('[data-pdp-size-modal-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  // ───────── BLOC 6 — DATE DE LIVRAISON ─────────
  function initDelivery(root) {
    var el = $('[data-pdp-delivery]', root);
    if (!el) return;
    var days = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    var months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    function addBiz(d0, n) { var d = new Date(d0), a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    var now = new Date(), s = $('[data-pdp-delivery-start]', el), e = $('[data-pdp-delivery-end]', el);
    if (s) s.textContent = fmt(addBiz(now, 2));
    if (e) e.textContent = fmt(addBiz(now, 4));
  }

  // ───────── STEP SELECTOR + matching variant combiné ─────────
  function initSteps(root) {
    var dataEl = $('[data-pack-variants]', root);
    if (!dataEl) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var optionCount = parseInt(root.getAttribute('data-option-count') || '1', 10);
    var foldOn = root.getAttribute('data-fold') === 'true';
    var lowThreshold = parseInt(root.getAttribute('data-low-threshold') || '5', 10);
    var shortName = root.getAttribute('data-short-name') || '';
    var form = $('[data-pack-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var addBtn = $('[data-pack-add]', root);
    var addLabel = $('[data-pack-add-label]', addBtn);
    var warn = $('[data-pack-warn]', root);
    var warnN = $('[data-pack-warn-n]', root);
    var progress = $('[data-pack-progress]', root);
    var priceEl = $('[data-pack-price]', root);
    var stickyPrice = $('[data-pack-sticky-price]', root);
    var stickyName = $('[data-pack-sticky-name]', root);
    var stickyBtn = $('[data-pack-sticky-add]', root);
    var steps = $all('[data-pack-step]', root);
    var total = steps.length;

    var selected = []; for (var i = 0; i < 3; i++) selected.push(null);
    var editing = {}; // optionIndex -> true si en cours d'édition (déplié manuellement)

    function matchVariant() {
      if (optionCount === 0) return variants.find(function (v) { return v.available; }) || variants[0];
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) { if (selected[i] == null || v['option' + (i + 1)] !== selected[i]) return false; }
        return true;
      });
    }
    function valueAvailable(oi, value) {
      return variants.some(function (v) {
        if (v['option' + (oi + 1)] !== value || !v.available) return false;
        for (var i = 0; i < optionCount; i++) { if (i === oi) continue; if (selected[i] != null && v['option' + (i + 1)] !== selected[i]) return false; }
        return true;
      });
    }
    function lowQtyFor(oi, value) {
      var v = variants.find(function (vv) {
        if (vv['option' + (oi + 1)] !== value) return false;
        for (var i = 0; i < optionCount; i++) { if (i === oi) continue; if (selected[i] != null && vv['option' + (i + 1)] !== selected[i]) return false; }
        return true;
      });
      return (v && v.inventory_managed && typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
    }

    function renderStep(step) {
      var oi = parseInt(step.getAttribute('data-pack-step'), 10);
      var sizesWrap = $('[data-pack-sizes-wrap]', step);
      var foldedWrap = $('[data-pack-folded]', step);
      var chosen = selected[oi];
      var folded = !!chosen && foldOn && total >= 3 && !editing[oi];
      step.classList.toggle('is-done', !!chosen);
      if (foldedWrap && sizesWrap) {
        foldedWrap.hidden = !folded;
        sizesWrap.hidden = folded;
        if (folded) { var pill = $('[data-pack-chosen-pill]', foldedWrap); if (pill) pill.textContent = chosen; }
      }
      // dispo + actif des pills
      $all('[data-value]', step).forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        btn.classList.toggle('is-active', val === chosen);
        btn.classList.toggle('is-oos', !valueAvailable(oi, val));
      });
      // stock bas
      var low = $('[data-pack-low]', step);
      if (low) {
        var q = chosen ? lowQtyFor(oi, chosen) : null;
        if (q != null && q > 0 && q <= lowThreshold) { var qe = $('[data-pack-low-qty]', low); if (qe) qe.textContent = q; var se = $('[data-pack-low-size]', low); if (se) se.textContent = chosen; low.hidden = false; }
        else low.hidden = true;
      }
    }
    function renderAll() {
      steps.forEach(renderStep);
      var done = 0; for (var i = 0; i < optionCount; i++) if (selected[i] != null) done++;
      var variant = matchVariant();
      var ready = optionCount === 0 ? !!variant : (done === optionCount);
      var available = ready && variant && variant.available;
      if (idInput && variant && available) idInput.value = variant.id;
      if (progress) progress.textContent = done;
      if (priceEl && variant) priceEl.innerHTML = moneyHtml(variant.price);
      if (stickyPrice && variant) stickyPrice.innerHTML = moneyHtml(variant.price);
      // CTA
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.classList.toggle('is-disabled', !available);
        if (addLabel) addLabel.innerHTML = available ? (addBtn.getAttribute('data-add-label') + ' · ' + moneyHtml(variant.price)) : addBtn.getAttribute('data-pick-label').replace('{n}', total);
      }
      var remaining = optionCount - done;
      if (warn) { warn.hidden = available || optionCount === 0; if (warnN) warnN.textContent = remaining; }
      // sticky
      if (stickyName) {
        var parts = []; for (var j = 0; j < optionCount; j++) parts.push(selected[j] || '—');
        stickyName.textContent = shortName + ' · ' + (available ? parts.join(' + ') + ' ✓' : done + '/' + optionCount + ' tailles');
      }
      if (stickyBtn) { stickyBtn.textContent = available ? 'Ajouter au panier' : 'Tailles'; stickyBtn.classList.toggle('is-disabled', !available); }
    }

    steps.forEach(function (step) {
      var oi = parseInt(step.getAttribute('data-pack-step'), 10);
      $all('[data-value]', step).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-oos')) return; // OOS = non sélectionnable
          selected[oi] = btn.getAttribute('data-value');
          editing[oi] = false;
          renderAll();
        });
      });
      var modify = $('[data-pack-modify]', step);
      if (modify) modify.addEventListener('click', function () { editing[oi] = true; renderStep(step); });
    });

    if (optionCount === 0 && idInput) { var v0 = matchVariant(); if (v0) idInput.value = v0.id; }
    renderAll();
  }

  // ───────── PANIER AJAX + DRAWER + TOAST ─────────
  function initCart(root) {
    var form = $('[data-pack-form]', root);
    var addBtn = $('[data-pack-add]', root);
    var stickyBtn = $('[data-pack-sticky-add]', root);
    var drawer = $('[data-pdp-cart]', root);
    var overlay = $('[data-pdp-cart-overlay]', root);
    var toast = $('[data-pdp-toast]', root);
    if (!form) return;
    function openDrawer() { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; if (typeof closeSheet === 'function') closeSheet(); }
    $all('[data-pdp-cart-close]', root).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    function showToast(msg) { if (!toast) return; var s = $('[data-pdp-toast-msg]', toast); if (s) s.textContent = msg; toast.classList.add('is-visible'); setTimeout(function () { toast.classList.remove('is-visible'); }, 3000); }
    function renderCart(cart, newKey) {
      if (!drawer) return;
      var body = $('[data-pdp-cart-body]', drawer), foot = $('[data-pdp-cart-foot]', drawer), countEl = $('[data-pdp-cart-count]', drawer);
      if (countEl) countEl.textContent = cart.item_count;
      renderCross(cart);
      var tiersC = drawer.querySelector('[data-qw-tiers]');
      if (cart.item_count === 0) { body.innerHTML = '<div class="cart__empty">Ton panier est vide.</div>'; if (foot) foot.hidden = true; if (tiersC) tiersC.style.display = 'none'; return; }
      if (tiersC) { tiersC.style.display = ''; if (window.QowaaTiers) window.QowaaTiers.render(tiersC, cart.total_price); }
      body.innerHTML = cart.items.map(function (it) {
        var isNew = newKey && it.key === newKey;
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var isGift = !!(it.properties && it.properties._qw_gift);
        var controls = isGift
          ? '<span class="cart-item__giftlbl">Cadeau offert</span>'
          : '<div class="cart-item__qtybar"><button type="button" class="cart-item__qbtn" data-pdp-line-minus aria-label="Diminuer">−</button><span class="cart-item__qval">' + it.quantity + '</span><button type="button" class="cart-item__qbtn" data-pdp-line-plus aria-label="Augmenter">+</button><button type="button" class="cart-item__rm" data-pdp-line-remove aria-label="Supprimer">Supprimer</button></div>';
        return '<div class="cart-item' + (isNew ? ' is-new' : '') + '" data-line-key="' + it.key + '"><div class="cart-item__media">' + img + '</div><div class="cart-item__info"><span class="cart-item__name">' + it.product_title + '</span>' + (variant ? '<span class="cart-item__variant">' + variant + '</span>' : '') + controls + '</div><span class="cart-item__price">' + (isGift ? 'Offert' : money(it.final_line_price)) + '</span></div>';
      }).join('');
      if (foot) {
        foot.hidden = false;
        var t = $('[data-pdp-cart-total]', foot); if (t) t.textContent = money(cart.total_price);
        var sh = $('[data-pdp-cart-shipping]', foot); if (sh) sh.textContent = cart.total_price >= 7900 ? '✓ Livraison offerte' : 'Plus que ' + money(7900 - cart.total_price) + ' pour la livraison offerte';
      }
      setTimeout(function () { var el = body.querySelector('.is-new'); if (el) el.classList.remove('is-new'); }, 1400);
    }
    function updateHeaderCount(c) { $all('.header__badge').forEach(function (b) { b.textContent = c; b.style.display = ''; }); }

    var cartBusy = false;
    function changeLine(key, qty) {
      if (cartBusy || !key) return;
      cartBusy = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart, null); updateHeaderCount(cart.item_count); })
        .catch(function () {}).finally(function () { cartBusy = false; });
    }
    var cartBodyEl = drawer ? $('[data-pdp-cart-body]', drawer) : null;
    if (cartBodyEl) cartBodyEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]'); if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qv = line.querySelector('.cart-item__qval');
      var cur = qv ? (parseInt(qv.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-pdp-line-plus]')) { changeLine(key, cur + 1); return; }
      if (e.target.closest('[data-pdp-line-minus]')) { changeLine(key, cur - 1); return; }
      if (e.target.closest('[data-pdp-line-remove]')) { changeLine(key, 0); return; }
    });
    var crossWrap = drawer ? $('[data-pdp-cart-cross]', drawer) : null;
    function renderCross(cart) {
      if (!crossWrap) return;
      // Rail « Complète ta tenue » = TOUS les articles (on ne masque plus ceux du panier) → plein + scrollable.
      crossWrap.hidden = !(cart && cart.item_count > 0);
    }
    var sizeSheet = drawer ? drawer.querySelector('[data-cart-sizesheet]') : null;
    var sheetRow = sizeSheet ? sizeSheet.querySelector('[data-sizesheet-row]') : null;
    var sheetTitle = sizeSheet ? sizeSheet.querySelector('[data-sizesheet-title]') : null;
    function openSheet(card) {
      if (!sizeSheet || !sheetRow || !card) return;
      var src = card.querySelector('[data-cross-sizes]');
      if (!src) return;
      var nameEl = card.querySelector('.cart-cross__name');
      sheetRow.innerHTML = src.innerHTML;
      if (sheetTitle) sheetTitle.textContent = nameEl ? ('Choisis ta taille — ' + nameEl.textContent.trim()) : 'Choisis ta taille';
      sizeSheet.classList.add('is-open');
      sizeSheet.setAttribute('aria-hidden', 'false');
    }
    function closeSheet() {
      if (!sizeSheet) return;
      sizeSheet.classList.remove('is-open');
      sizeSheet.setAttribute('aria-hidden', 'true');
    }
    function crossAdd(el) {
      if (cartBusy) return;
      var vid = el.getAttribute('data-variant-id'); if (!vid) return;
      cartBusy = true; el.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { closeSheet(); renderCart(cart, null); updateHeaderCount(cart.item_count); })
        .catch(function () {}).finally(function () { cartBusy = false; el.classList.remove('is-loading'); });
    }
    if (crossWrap) crossWrap.addEventListener('click', function (e) {
      var tog = e.target.closest('[data-cross-toggle]');
      if (tog) { e.preventDefault(); openSheet(tog.closest('.cart-cross')); return; }
      var addEl = e.target.closest('[data-pdp-cross-add]');
      if (addEl) { e.preventDefault(); crossAdd(addEl); return; }
    });
    if (sizeSheet) sizeSheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizesheet-close]')) { closeSheet(); return; }
      var addEl = e.target.closest('[data-cross-add]');
      if (addEl) { e.preventDefault(); crossAdd(addEl); }
    });
    function add() {
      if (addBtn && addBtn.disabled) return;
      var idInput = $('input[name="id"]', form);
      var fd = new FormData(); fd.append('id', idInput ? idInput.value : ''); fd.append('quantity', 1);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { showToast(res.body.description || 'Erreur — réessaie.'); return; }
          var added = res.body;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            renderCart(cart, added.key); updateHeaderCount(cart.item_count);
            showToast('✓ ' + added.product_title + ' ajouté au panier');
            setTimeout(openDrawer, 50);
          });
        })
        .catch(function () { showToast('Erreur réseau — réessaie.'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (stickyBtn.classList.contains('is-disabled')) { scrollToSteps(root); return; } add(); });
  }

  function scrollToSteps(root) {
    var steps = $('[data-pack-steps]', root) || $('.steps', root);
    if (!steps) return;
    steps.scrollIntoView({ behavior: 'smooth', block: 'center' });
    steps.animate([{ outline: '2px solid var(--qw-warning)', outlineOffset: '4px' }, { outline: '2px solid transparent', outlineOffset: '4px' }], { duration: 1200 });
  }

  // ───────── STICKY CTA visibilité ─────────
  function initSticky(root) {
    var sticky = $('[data-pack-sticky]', root), gallery = $('[data-pdp-gallery]', root);
    if (!sticky || !gallery) return;
    function onScroll() {
      // mobile + desktop : visible quand la galerie est passée au-dessus du viewport (sauf tout en bas)
      var gb = gallery.getBoundingClientRect().bottom;
      var docBottom = document.body.scrollHeight - (window.scrollY + window.innerHeight);
      sticky.classList.toggle('is-visible', gb < 0 && docBottom > 200);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function initPack(root) {
    initGallery(root); initAccordions(root); initSizeModal(root); initSteps(root); initCart(root); initSticky(root); initDelivery(root);
  }
  function boot() { $all('[data-pack-root]').forEach(initPack); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-pack-root]'); if (r) initPack(r); });
})();
